module.exports = __webpack_public_path__ + "f05875b8ea0fa9c7ac1dea461984c83e.svg";